import { render, staticRenderFns } from "./DuesPayment.vue?vue&type=template&id=3a6f972b&scoped=true&"
import script from "./DuesPayment.vue?vue&type=script&lang=js&"
export * from "./DuesPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6f972b",
  null
  
)

export default component.exports